import axios from 'axios';
import ApiUrl from './config';

export async function reorderMatches(
  bracketId: number,
  round: number,
  matchIds: number[]
): Promise<void> {
  await axios.put(`${ApiUrl}/api/Match/ReorderMatches`, {
    bracketId,
    round,
    matchIds,
  });
}
